<div class="expired-overlay">

    <div class="expired-card">

        <div class="expired-icon">
            !
        </div>

        <h1>
            Subscription Expired
        </h1>

        <p class="expired-message">

            Your subscription has expired.

            You cannot continue using the application
            until the subscription is renewed.

        </p>

        <!-- <button type="button" class="renew-button" (click)="onRenew()">

            Renew Subscription

        </button> -->

        <p class="contact-message">

            Please contact your administrator if you
            need assistance.

        </p>

    </div>

</div>